import { module as modujs } from "modujs";

import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(SplitText, CustomEase);

CustomEase.create("custom", "0, 0.55, 0.45, 1");

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		CustomEase.create("custom", "0, 0.55, 0.45, 1");

		gsap.registerEffect({
			name: "text",
			effect: (targets, config) => {
				gsap.set(targets, {
					autoAlpha: 1,
					fontKerning: "none",
				});

				let split = new SplitText(targets, { type: "lines" });
				let splitWrap = new SplitText(targets, { type: "lines", linesClass: "o-split-line" });

				gsap.set(split.lines, {
					opacity: 0,
				});

				return gsap.fromTo(
					split.lines,
					{
						yPercent: 140,
						skewX: -5,
						rotate: 2.5,
					},
					{
						yPercent: 0,
						skewX: 0,
						rotate: 0,
						duration: 1.6,
						ease: "expo.out",
						stagger: 0.1,
						onStart: function () {
							gsap.fromTo(
								split.lines,
								{
									opacity: 0,
								},
								{
									opacity: 1,
									ease: "none",
									duration: 0.1,
								},
							);
						},
						onComplete: function () {
							splitWrap.revert();
							split.revert();
						},
					},
				);
			},
			extendTimeline: true,
		});

		gsap.registerEffect({
			name: "fade-up",
			effect: (targets, config) => {
				return gsap.fromTo(
					targets,
					{
						y: config.y,
						opacity: 0,
					},
					{
						y: 0,
						opacity: 1,
						duration: config.duration,
						ease: config.ease,
						onStart: function () {
							gsap.set(targets, { autoAlpha: 1 });
						},
					},
				);
			},
			defaults: { y: 56, duration: 1, ease: "custom" },
			extendTimeline: true,
		});

		gsap.registerEffect({
			name: "fade-down",
			effect: (targets, config) => {
				return gsap.fromTo(
					targets,
					{
						y: config.y,
						opacity: 0,
					},
					{
						y: 0,
						opacity: 1,
						duration: config.duration,
						ease: config.ease,
						onStart: function () {
							gsap.set(targets, { autoAlpha: 1 });
						},
					},
				);
			},
			defaults: { y: -56, duration: 1, ease: "custom" },
			extendTimeline: true,
		});

		gsap.registerEffect({
			name: "fade",
			effect: (targets, config) => {
				return gsap.fromTo(
					targets,
					{
						opacity: 0,
					},
					{
						opacity: 1,
						duration: config.duration,
						ease: config.ease,
						onStart: function () {
							gsap.set(targets, { autoAlpha: 1 });
						},
					},
				);
			},
			defaults: { duration: 1, ease: "custom" },
			extendTimeline: true,
		});

		gsap.registerEffect({
			name: "slide-up",
			effect: (targets, config) => {
				return gsap.fromTo(
					targets,
					{
						yPercent: config.yPercent,
					},
					{
						yPercent: 0,
						duration: config.duration,
						ease: config.ease,
						onStart: function () {
							gsap.set(targets, { autoAlpha: 1 });
						},
					},
				);
			},
			defaults: { yPercent: 50, duration: 1, ease: "custom" },
			extendTimeline: true,
		});

		gsap.registerEffect({
			name: "zoom-out",
			effect: (targets, config) => {
				const tl = gsap.timeline({
					onStart: function () {
						gsap.set(targets, { autoAlpha: 1 });
					},
				});

				tl.fromTo(
					targets,
					{
						opacity: 0,
					},
					{
						opacity: 1,
						duration: 0.2,
						ease: "none",
					},
				);

				tl.fromTo(
					targets,
					{
						scale: 1.1,
					},
					{
						scale: 1,
						duration: config.duration,
						ease: config.ease,
					},
					"<",
				);

				return tl;
			},
			defaults: { duration: 1.4, ease: "custom" },
			extendTimeline: true,
		});
	}

	destroy() {}
}
